import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { EnvelopeSimple } from "@phosphor-icons/react";
import { api, formatApiErrorDetail } from "../../../lib/api";

const parse = (t) => t.split(/[\s,;]+/).map((x) => x.trim()).filter(Boolean);

export const ConsultantEmails = ({ slug, name }) => {
  const [text, setText] = useState("");
  const [saved, setSaved] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/admin/consultant-emails").then(({ data }) => { const v = (data[slug] || []).join(", "); setText(v); setSaved(v); }).catch(() => toast.error("Couldn't load consultant emails - please refresh."));
  }, [slug]);

  const save = async () => {
    setBusy(true);
    try {
      const { data } = await api.put(`/admin/consultant-emails/${slug}`, { emails: parse(text) });
      const v = data.emails.join(", ");
      setText(v); setSaved(v);
      toast.success(data.emails.length ? `${name} will get "New CCPC booking" emails` : `Booking emails to ${name} turned off`);
    } catch (e) {
      toast.error(e.response?.status === 422 ? "Please check the email address - one of them isn't valid." : formatApiErrorDetail(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };

  return (
    <div data-testid={`consultant-emails-${slug}`} className="p-5 bg-white border border-stone-200/60 rounded-md">
      <div className="flex items-center gap-2 font-serif text-xl"><EnvelopeSimple size={18} /> Booking emails for {name}</div>
      <p className="text-xs text-ink-muted mt-1">A &quot;New CCPC booking&quot; email (with calendar invite) goes here as soon as a booking is confirmed. Separate several addresses with commas.</p>
      <div className="mt-3 flex flex-wrap gap-2">
        <input value={text} onChange={(e) => setText(e.target.value)} placeholder="e.g. name@nhs.net" data-testid={`consultant-emails-input-${slug}`}
          className="flex-1 min-w-[220px] rounded-sm border border-stone-300 bg-white px-3 py-2 text-sm" />
        <button type="button" onClick={save} disabled={busy || saved === null || text === saved} data-testid={`consultant-emails-save-${slug}`}
          className="btn-secondary disabled:opacity-50">{busy ? "Saving…" : "Save email"}</button>
      </div>
      {saved === "" && <p data-testid={`consultant-emails-none-${slug}`} className="mt-2 text-xs text-red-700">No address yet - this consultant isn&apos;t being emailed about bookings.</p>}
    </div>
  );
};
